import React from "react";

// v31.01: TelegramNotInitiated banner helper
// If the error string starts with __TELEGRAM_NOT_INITIATED__<botname>, returns
// a JSX banner with a clickable Telegram deep link. Otherwise returns null —
// caller should render the error as a normal string.
export function renderTelegramNotInitiated(err) {
  if (typeof err !== 'string') return null;
  const PFX = '__TELEGRAM_NOT_INITIATED__';
  if (!err.startsWith(PFX)) return null;
  // v31.02: fallback на актуальный бот (раньше 'Blitzfinance_bot' — старый, token revoked
  // после bot migration 2026-04-17). Source of truth — server возвращает data.botUsername,
  // этот fallback срабатывает только если parse payload пустой.
  const bot = err.slice(PFX.length) || 'blit_finance_bot';
  const url = 'https://t.me/' + bot;
  return React.createElement(
    'div',
    {
      style: {
        background: '#3a1d1d', border: '1px solid #e2605c', color: '#ffdcdc',
        padding: '12px 14px', borderRadius: 8, marginTop: 10,
        fontSize: 13, lineHeight: 1.45, textAlign: 'left'
      }
    },
    React.createElement('div', { style: { fontWeight: 600, marginBottom: 6 } },
      '\u26A0\uFE0F Telegram 2FA not set up'),
    React.createElement('div', null,
      "You haven't started a chat with our 2FA bot yet, so we can't send you the login code."),
    React.createElement('div', { style: { marginTop: 8 } },
      React.createElement('a', {
        href: url, target: '_blank', rel: 'noreferrer',
        style: {
          display: 'inline-block', background: '#2ea6ff', color: '#fff',
          padding: '6px 12px', borderRadius: 6, textDecoration: 'none', fontWeight: 600
        }
      }, 'Open @' + bot),
      React.createElement('span', { style: { marginLeft: 10, opacity: 0.8 } },
        'send /start, then click Login again.')
    )
  );
}
